import { useEffect } from 'react';
import { useOnboardingOptional } from './OnboardingContext';

/**
 * Rendered by AppLayout: landing in the signed-in app shell is the signal that
 * the tour may open automatically (never on auth/public pages, which use
 * AuthLayout). The provider decides whether it actually opens (once per session,
 * only while the user's "show again" setting is on). No-op without a provider.
 */
export function OnboardingAutoStart() {
  const requestAutoStart = useOnboardingOptional()?.requestAutoStart;
  useEffect(() => {
    requestAutoStart?.();
  }, [requestAutoStart]);
  return null;
}

export default OnboardingAutoStart;
